<template>
  <div class="app-container">
    <el-card class="mb5">
      <el-form
        ref="form" :model="queryForm.params" label-width="auto"
        size="small"
        label-position="top"
      >
        <div class="searchContainer">
          <el-row :gutter="20">
            <el-col :span="6">
              <!--付款状态-->
              <el-form-item :label="$t('receivablePayable.PaymentStatus')" prop="payableStatus">
                <el-select
                  v-model="queryForm.params.payableStatus"
                  filterable
                  multiple
                  :placeholder="$t('operationCenter.PleaseSelect')"
                  clearable
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in PAYABLE_STATUS" :key="item.value" :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--付款主体-->
              <el-form-item :label="$t('GlobalSetObj.SubjectPayment')" prop="providerId">
                <QueryProviderCmp
                  :val="queryForm.params.providerId"
                  :type="queryForm.params.payableTypes"
                  @change="changeProvider"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--网点-->
              <el-form-item :label="$t('basicData.Outlets')" prop="siteIds">
                <QuerySiteCmp
                  :val="queryForm.params.siteIds"
                  :multiple="true"
                  :multiple-limit="10"
                  :provider-id="queryForm.params.providerId"
                  :payable-types="queryForm.params.payableTypes"
                  @change="val => queryForm.params.siteIds = val"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--业务类型-->
              <el-form-item :label="$t('collectionCenter.businessT')" prop="businessType">
                <el-select
                  v-model="queryForm.params.businessType"
                  filterable
                  :placeholder="$t('operationCenter.PleaseSelect')"
                  clearable
                  style="width: 100%;"
                >
                  <!--全部-->
                  <el-option :label="$t('basicData.all')" :value="null" />
                  <el-option
                    v-for="item in P_BUSINESS_TYPE"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--账单类型-->
              <el-form-item :label="$t('collectionCenter.TypeBill')" prop="payableTypes">
                <el-select
                  v-model="queryForm.params.payableTypes"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  clearable
                  style="width: 100%"
                  @change="val => queryForm.params.providerId = ''"
                >
                  <el-option
                    v-for="item in PAYABLE_TYPE"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--邮件发送状态-->
              <el-form-item :label="$t('receivablePayable.MailSendingStatus')" prop="emailSendingStatus">
                <el-select
                  v-model="queryForm.params.emailSendingStatus"
                  filterable
                  :placeholder="$t('receivablePayable.PleaseSelect')"
                  clearable
                  style="width: 100%;"
                >
                  <!--全部-->
                  <el-option :label="$t('basicData.all')" value="" />
                  <el-option
                    v-for="item in EMAIL_STATUS"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--账单时间-->
              <el-form-item :label="$t('receivablePayable.BillingDate')" prop="payableTimes">
                <el-date-picker
                  v-model="queryForm.params.payableTimes"
                  style="width: 100%"
                  type="daterange"
                  :range-separator="$t('operationCenter.to')"
                  :start-placeholder="$t('operationCenter.startDate')"
                  :end-placeholder="$t('operationCenter.endDate')"
                  value-format="yyyy-MM-dd"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--是否存在文件-->
              <el-form-item :label="$t('basicData.ExistenceDocuments')" prop="haveFile">
                <el-select v-model="queryForm.params.haveFile" :placeholder="$t('GlobalSetObj.pleaseChoose')" style="width: 100%">
                  <el-option :label="$t('GlobalSetObj.all')" :value="0" />
                  <el-option :label="$t('GlobalSetObj.yes')" :value="1" />
                  <el-option :label="$t('GlobalSetObj.No')" :value="2" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--是否请款-->
              <el-form-item :label="$t('receivablePayable.areYouRequestingPayment')" prop="requestPaymentStatus">
                <el-select
                  v-model="queryForm.params.requestPaymentStatus " :placeholder="$t('GlobalSetObj.pleaseChoose')" style="width: 100%"
                  clearable
                >
                  <!--全部-->
                  <el-option :label="$t('GlobalSetObj.all')" value="" />
                  <!--是-->
                  <el-option :label="$t('GlobalSetObj.yes')" :value="1" />
                  <!--否-->
                  <el-option :label="$t('GlobalSetObj.No')" :value="0" />
                  <!--部分请款-->
                  <el-option :label="$t('receivablePayable.partialPaymentRequest')" :value="2" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--付款单号-->
              <el-form-item :label="$t('receivablePayable.PaymentSlipNumber')" label-width="120px">
                <template slot="label">
                  <el-select
                    v-model="typeNumber"
                    filterable
                    :placeholder="$t('operationCenter.PleaseSelect')"
                    clearable
                    style="width: 100%; height:  28px;"
                  >
                    <!--付款单号-->
                    <el-option :label="$t('receivablePayable.PaymentSlipNumber')" :value="1" />
                    <!--账单批次号-->
                    <el-option :label="$t('receivablePayable.BillingBatchNumber')" :value="2" />
                  </el-select>
                </template>
                <InputTextareaCmp
                  ref="inputTextareaRef"
                  :val="searchNum"
                  :max-length="200"
                  @input="(_, val) => searchNum = val"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        @click="searchResources()"
      >
        {{ $t('operationCenter.Procurar') }}
      </el-button>
      <!--重 置-->
      <el-button
        size="small"
        icon="el-icon-refresh"
        @click="onReset"
      >{{ $t('basicData.reset') }}</el-button>
    </el-card>
    <el-card>
      <div class="feet-s mb10">
        <div class="feet-r">
          <!--付款-->
          <el-button
            v-permit:remove="'btn:payableManagement:payableCollection:approved'"
            size="small"
            type="primary"
            :disabled="isPayBut"
            @click="operationBtn(1)"
          >{{ $t('receivablePayable.Verification') }}</el-button>

          <!-- 发送账单 -->
          <el-button
            v-permit:remove="'btn:payableManagement:payableCollection:SendBill'"
            size="small"
            class="feet-btn"
            type="primary"
            :disabled="isSendBillBut"
            @click="onSendBill(1)"
          >{{ $t('receivablePayable.SendBill') }}</el-button>

          <!-- 批量发送邮件-->
          <el-button
            v-permit:remove="'btn:payableManagement:payableCollection:SendBill'"
            type="primary"
            size="small"
            class="feet-btn"
            :disabled="!selectData.length"
            @click="onSendBill(2)"
          >
            {{ $t('receivablePayable.batchSendEmail') }}
          </el-button>

          <!--自定义栏目-->
          <CustomStatusBar
            class="feet-btn"
            :columns-data="PAYABLE_TABLE_COLUMNS"
            :params="searchParams"
            :save-params="customParams"
            @updateColumns="updateColumns"
          />

          <!-- 编辑文件 -->
          <el-button
            v-permit:remove="'btn:payableManagement:payableCollection:EditFile'"
            size="small"
            type="primary"
            class="feet-btn"
            :disabled="isEditFile"
            @click="openUpdateFile"
          >{{ $t('GlobalSetObj.edit') }}{{ $t('base.document') }}</el-button>

          <!--撤回-->
          <el-button
            :disabled="recallIds.length === 0"
            type="danger"
            size="small"
            class="feet-btn"
            @click="recallAll()"
          >{{ $t('receivablePayable.withdraw') }}</el-button>

          <!-- 付款（含弹出窗） -->
          <BradescoCmp :select-data="selectData" @updatePage="getExaminePage" />

          <!--付款（Santander）-->
          <payment-santander :select-data="selectData" @updatePage="getExaminePage" />

          <el-popover
            placement="bottom-start"
            trigger="hover"
          >
            <div class="feet">
              <!--标记请款-->
              <el-button
                size="small"
                type="warning"
                @click="paymentRequest(1)"
              >{{ $t('receivablePayable.markPaymentRequest') }}</el-button>
              <!--取消请款-->
              <el-button
                size="small"
                class="feet-btn"
                @click="paymentRequest(0)"
              >{{ $t('receivablePayable.cancelPaymentRequest') }}</el-button>
            </div>
            <!-- 请款 -->
            <el-button
              slot="reference"
              v-permit:remove="'btn:payableManagement:payableCollection:examine'"
              type="success"
              size="small"
            >{{ $i18n.t('receivablePayable.paymentRequest') }}</el-button>
          </el-popover>
        </div>

        <div class="feet-r">
          <!-- 导出账单文件 -->
          <el-button
            v-permit:remove="'btn:payableManagement:payableCollection:exportBillFile'" size="small" type="info"
            @click="onExportBillFile"
          >{{ $t('basicData.导出账单文件') }}<i class="el-icon-download el-icon--right" /></el-button>

          <!-- 导出 付款单信息 -->
          <el-button
            v-permit:remove="'btn:payableManagement:payableCollection:export'" size="small" type="info"
            class="feet-btn"
            @click="onExport"
          >{{ $t('CenterForSorting.export') }}{{ $t('receivablePayable.PaymentOrderInformation') }}<i class="el-icon-download el-icon--right" /></el-button>
        </div>
      </div>

      <!-- 费用统计 -->
      <TableStatisticiansCmp :table-data="tableData" />

      <el-table
        ref="table"
        :key="tableKey"
        class="table-height"
        :data="tableData"
        :height="tableHeightRow.height"
        border
        row-key="idCopy"
        :tree-props="{ children: 'meetSiteBill', hasChildren: true }"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
          :selectable="selectable"
        />
        <el-table-column
          v-for="item in currentColumns"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
          :align="item.align"
          :min-width="item.width"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <!--账单批次号-->
            <span v-if="item.prop === 'payableNumber'">
              <span v-if="scope.row.isParent === true" class="batchNumber" @click="showBillBatchNumber(scope.row)">{{ scope.row.payableNumber }}</span>
              <span v-else>{{ scope.row.billBatchNumber }}</span>
            </span>
            <div v-else-if="item.prop === 'businessType'">
              <!--揽收-->
              <span v-if="scope.row.businessType === 2">{{ $t('collectionCenter.lanshou') }}</span>
              <!--派送-->
              <span v-else-if="scope.row.businessType === 3">{{ $t('collectionCenter.dispatch') }}</span>
              <!--转运-->
              <span v-else-if="scope.row.businessType === 1">{{ $t('collectionCenter.turnTransport') }}</span>
            </div>
            <div v-else-if="item.prop === 'billFee'">
              <span v-if="scope.row.isParent === true">{{ scope.row.billFee }}</span>
              <span v-else>{{ scope.row.totalReceivable }}</span>
            </div>
            <div v-else-if="item.prop === 'createTime'">
              <span>{{ scope.row.createTime ? scope.row.createTime.replace('T', ' ') : '' }}</span>
            </div>
            <div v-else-if="item.prop === 'auditTime'">
              <span>{{ scope.row.auditTime ? scope.row.auditTime.replace('T', ' ') : '' }}</span>
            </div>
            <div v-else-if="item.prop === 'remark'">
              <div class="remarkStyle" @click="showImg($event)" v-html="scope.row.remark" />
            </div>

            <!--是否请款-->
            <div v-else-if="item.prop === 'requestPaymentStatus'">
              <el-tag v-if="scope.row.requestPaymentStatus === 1" type="success">{{ $t('GlobalSetObj.yes') }}</el-tag>
              <el-tag v-if="scope.row.requestPaymentStatus === 0" type="danger">{{ $t('GlobalSetObj.No') }}</el-tag>
              <el-tag v-if="scope.row.requestPaymentStatus === 2" type="warning">{{ $t('receivablePayable.partialPaymentRequest') }}</el-tag>
            </div>

            <!-- 邮件发送状态 -->
            <div v-else-if="item.prop === 'emailSendingStatus' && scope.row.emailSendingStatus">
              <!--              <el-tag v-if="scope.row.emailSendingStatus === 1" type="success">{{ $t('collectionCenter.sent') }}</el-tag>-->
              <!--              <el-tag v-else-if="scope.row.emailSendingStatus === 2">{{ $t('collectionCenter.NotSent') }}</el-tag>-->
              <!--              <el-tag v-else-if="scope.row.emailSendingStatus === 3" type="info">{{ $t('collectionCenter.InTransit') }}</el-tag>-->
              <!--              <el-tag v-else-if="scope.row.emailSendingStatus === 4" type="danger">{{ $t('collectionCenter.SendFailure') }}</el-tag>-->

              <el-tag
                :type="EMAIL_STATUS[scope.row.emailSendingStatus].type"
              >{{ EMAIL_STATUS[scope.row.emailSendingStatus].label }}</el-tag>
            </div>

            <!-- 文件 -->
            <div v-else-if="item.prop === 'emailSenderFileUrl'" style="display: flex;flex-wrap: wrap;">
              <el-link
                v-for="(key) of scope.row.allFileList" :key="key.fileUrl" type="success"
                :href="key.fileUrl" target="_blank" style="margin-right: 10px;"
              >{{ key.fileName }}</el-link>
            </div>

            <div v-else>{{ scope.row[item.prop] }}</div>
          </template>
        </el-table-column>
        <!--操作-->
        <el-table-column
          :label="$t('basicData.operate')"
          align="center"
          width="140"
          fixed="right"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.payableStatus === 0">
              <el-button
                v-permit:remove="'btn:payableManagement:payableCollection:recall'"
                type="danger"
                size="mini"
                @click="recall(scope.row)"
              >{{ $t('receivablePayable.withdraw') }}</el-button> <!--撤回-->
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页工具 -->
      <div class="pagination">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="queryForm.pageNumber"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size.sync="queryForm.pageSize"
          :total="total"
          background
          style="margin: 10px 0"
          @current-change="getExamineCurrentPage"
          @size-change="getExamineSizePage"
        />
      </div>
    </el-card>

    <!--  对账批次详情  -->
    <el-drawer
      :title="$t('receivablePayable.ReconcileBatchDetails') + '-' + batchNumber"
      :append-to-body="true"
      :visible.sync="showDetail"
      direction="ltr"
      custom-class="drawerClass"
      :label="$t('receivablePayable.ReconcileBatchDetails')"
      size="80%"
    >
      <batch-number-detail
        :key="batchNumber"
        :batch-number="batchNumber"
        :bill-batch-data="billBatchData"
        @closeDetail="closeDetail"
      />
    </el-drawer>
    <!--付款-->
    <el-dialog
      :title="$t('receivablePayable.Verification')"
      :visible.sync="showCollection"
      :custom-class="'dialogClass'"
      width="80%"
    >
      <collection-detail
        :key="collectionKey"
        :recharge-data="selectData[0]"
        :account-option="accountOption"
        @collectionUpdate="collectionUpdate"
      />
    </el-dialog>
    <div class="imgs">
      <el-image-viewer v-if="imageViewerObj.showViewer" :on-close="closeViewer" :url-list="imageViewerObj.imgArr" />
    </div>

    <!-- 发送邮件确认 -->
    <el-dialog
      :title="$t('receivablePayable.SendEmailConfirmation')"
      :visible.sync="sendBillRow.isShow"
      width="500px"
    >
      <EnvieUmEmailCmp
        v-if="sendBillRow.isShow"
        :row="sendBillRow.row"
        @close="onEnvUmEmailClose"
      />
    </el-dialog>

    <!-- 编辑文件 -->
    <UpdateFileCmp ref="updateFileRef" @update="getExaminePage" />
  </div>
</template>

<script>
import { getUserIdAndNameObj } from '@/enums/storageEnum';
import batchNumberDetail from './cmp/batchNumberDetail';
import { apiSitePayableGetPage } from '@/api/finance/basicData';
import { accountPage } from '@/api/finance/partition';
import {
  apiSitePayableWithdraw,
  apiSitePayableExport,
  apiMarkRequestPaymentStatus,
  apiSitePayableSendMail
} from '@/api/finance/receivables';
import { cloneDeep } from 'lodash-es';
import { goFinanceExportPage } from '@/utils/goExportList.js';
import estimateTableHeight from '@/views/finance/mixins/estimateTableHeight.js';
import { exportFile, getFileUrl } from './utils';
import { P_BUSINESS_TYPE, PAYABLE_TYPE } from '@/views/finance/enums.js';
import { PAYABLE_STATUS, PAYABLE_TABLE_COLUMNS, EMAIL_STATUS } from './enums.js';

export default {
  name: 'PayableCollection',

  components: {
    batchNumberDetail,
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer'),
    'collection-detail': () => import('./cmp/collectionDetail'),
    EnvieUmEmailCmp: () => import('./cmp/EnvieUmEmailCmp.vue'),
    'payment-santander': () => import('./cmp/optionBut/paymentSantander.vue'),
    TableStatisticiansCmp: () => import('./cmp/TableStatisticiansCmp.vue'),
    UpdateFileCmp: () => import('./cmp/UpdateFileCmp.vue'),
    QuerySiteCmp: () => import('@/views/finance/cmp/Query/QuerySiteCmp.vue'),
    BradescoCmp: () => import('./cmp/optionBut/BradescoCmp.vue'),
    InputTextareaCmp: () => import('@/views/finance/cmp/Query/InputTextareaCmp.vue'),
    QueryProviderCmp: () => import('@/views/finance/cmp/Query/QueryProviderCmp.vue'),
    CustomStatusBar: () => import('@/components/customStatusBar/index.vue')
  },

  mixins: [estimateTableHeight],
  data() {
    return {
      PAYABLE_TABLE_COLUMNS,
      PAYABLE_TYPE, // 账单类型
      P_BUSINESS_TYPE, // 业务类型
      PAYABLE_STATUS, // 付款状态
      EMAIL_STATUS, // 邮件发送状态
      queryForm: {
        orderDirection: 'DESC',
        pageNumber: 1,
        pageSize: 10,
        params: {
          payableStatus: [], // 付款状态
          providerId: '', // 业务主体
          siteIds: [], // 网点
          businessType: null, // 业务类型
          emailSendingStatus: '', // 邮件发送状态
          payableTypes: '', // 账单类型
          payableTimes: [], // 账单时间
          haveFile: 0, // 是否存在文件
          requestPaymentStatus: '', // 是否请款
          payableNumber: '', // 付款单号
          billBatchNumber: '' // 账单批次号
        }
      },
      // createUser: [],
      showDetail: false,
      tableData: [],
      total: 0,
      tableKey: new Date().getTime(),
      batchNumber: '',
      billBatchData: {},
      showReceivableManage: false,
      selectData: [],
      showCollection: false,
      collectionKey: new Date().getTime(),
      accountOption: [],
      imageViewerObj: {
        imgArr: [],
        showViewer: false
      },
      typeNumber: 1,
      searchNum: '', // 多行输入框
      // 发送邮件
      sendBillRow: {
        isShow: false,
        row: {
          payableNumber: '', // 付款单号、对账批次号
          providerId: 0 // 供应商id
        }
      },
      recallIds: [],
      currentColumns: [],
      searchParams: {
        type: 0,
        menuEnum: 'copeWithNucleus'
      },
      customParams: {
        templateField: '',
        templateName: '应付账单核付',
        userId: '',
        type: 0,
        menuEnum: 'copeWithNucleus'
      }
    };
  },
  computed: {
    // 发送账单按钮 禁用状态
    isSendBillBut() {
      const len = this.selectData.length;
      // 仅能选中一个对账批次号的数据且账单类型不为邮局派送
      const flag = this.selectData.every(item => item.payableType !== 6);
      return len !== 1 || !flag;
    },

    // 文件编辑-请款状态不可编辑
    isEditFile() {
      const len = this.selectData.length;
      if (len !== 1) {
        return true;
      }
      const row = this.selectData[0];
      const { requestPaymentStatus } = row;
      console.log(row, 'row', len);
      return !!requestPaymentStatus;
    },

    // 付款按钮 已核付、付款中禁用
    isPayBut() {
      const { selectData } = this;
      if (selectData.length !== 1) {
        return true;
      }
      return [1, 3].includes(selectData[0].payableStatus);
    }
  },
  created() {
    this.createUser = getUserIdAndNameObj();
    this.getAccountOption();
    this.getExaminePage();
  },
  methods: {
    // 更新自定义栏目columns
    updateColumns(list) {
      this.$nextTick(() => {
        this.currentColumns = cloneDeep(list);
        this.tableKey = new Date().getTime();
      });
      // console.log(list, '列表呈现的columns');
    },
    // 批量撤回
    recallAll() {
      if (this.recallIds.length > 10) {
        this.$message.warning(this.$t('collectionCenter.SelectUpTo10PiecesOfData'));
        return;
      }
      if (this.recallIds.length === 0) {
        this.$message.warning(this.$t('collectionCenter.PleaseSelectDataThatCanBeRecalled'));
        return;
      }
      const param = {
        payableNumbers: this.recallIds
      };
      this.$confirm(this.$i18n.t('receivablePayable.AreYouSureYouWantToWithdraw'), this.$i18n.t('basicData.tips'), { // '确定要撤回?'
        confirmButtonText: this.$i18n.t('basicData.determine'), // '确定',
        cancelButtonText: this.$i18n.t('basicData.Cancel'), // '取消',
        type: 'warning'
      }).then(() => {
        apiSitePayableWithdraw(param).then(res => {
          if (res.code === 200) {
            this.$message.success(this.$i18n.t('basicData.TheOperationSucceeded')); // 操作成功
            this.getExaminePage();
          }
        });
      });
    },
    changeProvider(val) {
      this.queryForm.params.providerId = val;
      this.queryForm.params.siteIds = [];
    },
    // 图片点击放大
    showImg(e) {
      if (e.target.tagName === 'IMG') {
        this.$set(this.imageViewerObj, 'showViewer', true);
        this.$set(this.imageViewerObj, 'imgArr', [e.target.src]);
      }
    },
    // 关闭查看图片
    closeViewer() {
      this.$set(this.imageViewerObj, 'showViewer', false);
    },
    // 子级禁止选择
    selectable(row) {
      return row.isParent;
    },
    // 更新页面
    collectionUpdate(type) {
      if (type === 2) {
        this.getExaminePage();
      }
      this.showCollection = false;
    },
    // 获取账户
    getAccountOption() {
      const param = {
        orderDirection: 'DESC',
        pageNumber: 1,
        pageSize: 1000000,
        params: {
          status: 1
        }
      };
      accountPage(param, false).then(res => {
        if (res.code === 200) {
          this.accountOption = res.data.records;
        }
      }).catch(err => {
        console.error(err);
      });
    },
    // 撤回
    recall(data) {
      const param = {
        payableNumbers: [data.payableNumber]
      };
      this.$confirm(this.$i18n.t('receivablePayable.AreYouSureYouWantToWithdraw'), this.$i18n.t('basicData.tips'), { // '确定要撤回?'
        confirmButtonText: this.$i18n.t('basicData.determine'), // '确定',
        cancelButtonText: this.$i18n.t('basicData.Cancel'), // '取消',
        type: 'warning'
      }).then(() => {
        apiSitePayableWithdraw(param).then(res => {
          if (res.code === 200) {
            this.$message.success(this.$i18n.t('basicData.TheOperationSucceeded')); // 操作成功
            this.getExaminePage();
          }
        });
      });
    },
    /**
     * 操作按钮
     * @param type 1 请款 0 取消请款
     */
    paymentRequest(type) {
      const list = this.selectData.length > 0 ? this.selectData : this.tableData;
      const ids = list.map(item => item.id);
      apiMarkRequestPaymentStatus({
        ids,
        requestPaymentStatus: type
      }).then(res => {
        if (res.code === 200) {
          this.$message.success(this.$i18n.t('basicData.TheOperationSucceeded')); // 操作成功
          this.getExaminePage();
        }
      }).catch(err => {
        console.error(err);
      });
    },
    // 关闭详情
    closeDetail() {
      this.showDetail = false;
    },
    // 获取列表数据
    getExaminePage() {
      const param = this.getQueryData();

      const randomString = (e, t) => {
        // e选取字符长度; t字符串
        e = e || 4;
        const a = t.length;
        let n = '';
        for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a));
        return n;
      };

      function repeat(payableNumber, random) {
        const randomStr = randomString(4, payableNumber);
        if (!random.includes(randomStr)) {
          random.push(randomStr);
          return randomStr;
        } else {
          repeat(payableNumber, random);
        }
      }

      function recurrence(table) {
        const randomArr = [];
        for (let i = 0; i < table.length; i++) {
          const randomId = repeat(table[i].payableNumber, randomArr);
          table[i]['idCopy'] = table[i].id + randomId;
          if (table[i].meetSiteBill && table[i].meetSiteBill.length > 0) {
            recurrence(table[i].meetSiteBill);
          }
        }
        return table;
      }

      const timeArr = ['acceptTime', 'auditTime', 'emailSendingTime'];
      apiSitePayableGetPage(param).then(res => {
        if (res.code === 200) {
          this.recallIds = [];
          res.data.records.map(item => {
            item['allFileList'] = [];
            for (const key in item) {
              // 时间处理
              if (timeArr.includes(key)) {
                if (item[key]) {
                  item[key] = item[key].replace('T', ' ');
                }
              }

              // 发送人
              if (key === 'emailSenderId') {
                item['emailSenderIdStr'] = this.createUser[item[key]];
              }

              // 文件处理
              if (key === 'emailSenderFileUrl') {
                if (item[key]) {
                  item['emailSenderFileUrlArr'] = item[key].split(',');
                } else {
                  item['emailSenderFileUrlArr'] = [];
                }
              }

              // 合并附件
              if (key === 'attachmentUrl' || key === 'emailSenderFileUrl') {
                if (item[key] && typeof item[key] === 'string') {
                  const arr = item[key].split(',');
                  const processedArr = arr.map((item, index) => ({
                    fileUrl: item,
                    fileName: key === 'emailSenderFileUrl' ? 'invoice' + (index + 1) : 'billfile' + (index + 1)
                  }));
                  item['allFileList'].push(...processedArr);
                  console.log('Updated allFileList:', item['allFileList']);
                }
              }
            }
          });
          this.tableData = recurrence(res.data.records).map(item => {
            const { payableStatus, payableType } = item;
            // delete item.requestPaymentStatus;

            const obj = {
              ...item,
              payableStatusStr: '',
              payableTypeStr: ''
            };

            // 付款状态
            obj.payableStatusStr = PAYABLE_STATUS[payableStatus]?.label ?? '';

            // 账单类型
            obj.payableTypeStr = PAYABLE_TYPE[payableType]?.label ?? '';

            return Object.freeze(obj);
          });
          this.total = res.data.total;
        }
      }).catch(err => {
        console.error(err);
      });
    },

    // 请求参数处理
    getQueryData() {
      const queryForm = cloneDeep(this.queryForm);
      const { params } = queryForm;

      const param = {
        orderDirection: 'DESC',
        pageNumber: queryForm.pageNumber,
        pageSize: queryForm.pageSize,
        params: {
          payableNumbers: [], // 收款单号
          billBatchNumbers: [], // 账单批次号
          siteIds: params.siteIds, // 网点
          businessType: params.businessType,
          providerId: params.providerId, // 业务主体
          payableStatus: params.payableStatus, // 收款状态
          emailSendingStatus: params.emailSendingStatus,
          requestPaymentStatus: params.requestPaymentStatus,
          payableTypes: [],
          payableTimes: [],
          haveFile: params.haveFile
        }
      };

      if (params.payableTypes !== '') {
        param.params.payableTypes = [params.payableTypes];
      }

      if (Array.isArray(queryForm.params.payableTimes)) {
        param.params.payableTimes = params.payableTimes;
      }

      // 付款单号 / 账单批次号
      if (this.searchNum.length >= 1) {
        const val = this.$refs.inputTextareaRef.getValue();
        if (this.typeNumber === 1) {
          param.params.payableNumbers = val;
        } else {
          param.params.billBatchNumbers = val;
        }
      }

      return param;
    },

    // 列表数据勾选
    handleSelectionChange(arr) {
      this.selectData = arr;
      this.recallIds = [];
      this.selectData.map(item => {
        if (this.$store.getters.button_permissions.includes('btn:payableManagement:payableCollection:recall') === true) {
          if (item.payableStatus === 0) {
            this.recallIds.push(item.payableNumber);
          }
        }
      });
    },
    // 获取对账批次详情
    showBillBatchNumber(data) {
      this.batchNumber = data.payableNumber;
      this.billBatchData = data;
      this.showDetail = true;
    },
    // 翻页
    getExamineCurrentPage(val) {
      this.queryForm.pageNumber = val;
      this.getExaminePage();
    },
    // 每页显示数量变化
    getExamineSizePage(val) {
      this.queryForm.pageNumber = 1;
      this.queryForm.pageSize = val;
      this.getExaminePage();
    },
    // 搜索
    searchResources() {
      this.queryForm.pageNumber = 1;
      this.getExaminePage();
    },
    // 重置
    onReset() {
      this.$refs.form.resetFields();
      this.$refs.inputTextareaRef.clear();
      this.getExaminePage();
    },
    // 核付
    operationBtn(type) {
      const len = this.selectData.length;
      if (len === 0) {
        this.$message.warning(this.$i18n.t('receivablePayable.SelectAtLeastOnePieceOfData')); // 最少要选择一条数据
        return;
      }
      if (type === 1) {
        if (len > 1) {
          this.$message.warning(this.$i18n.t('receivablePayable.OnlyOnePieceOfDataCanBeSelected')); // 最少要选择一条数据
          return;
        }
        this.collectionKey = new Date().getTime();
        this.showCollection = true;
        return false;
      }
    },

    /**
     * 发送账单
     * @param type 1 单个 2 批量
     */
    onSendBill(type) {
      const { selectData } = this;
      if (type === 1) {
        if (selectData.length !== 1) {
          this.$message.warning(this.$i18n.t('receivablePayable.OnlyOnePieceOfDataCanBeSelected')); // 最少要选择一条数据
          return;
        }

        // 当前已经发送发的邮件数量
        const { emailSendingCount } = selectData[0];
        if (emailSendingCount >= 3) {
          const str = this.$i18n.t('driver.modalSendButton');// 发送
          const str2 = this.$i18n.t('bank.email');// 邮件
          const str3 = this.$i18n.t('newOrder.Quantity');// 次数
          // const str4 = this.$i18n.t('collectionCenter.outRange');// 超出范围
          this.$message.warning(str + str2 + str3 + '(>=3)');
          return;
        }

        this.sendBillRow.isShow = true;
        this.sendBillRow.row = cloneDeep(this.selectData[0]);
        // const { payableNumber, providerId } = this.selectData[0];
        // this.sendBillRow.row.payableNumber = payableNumber;
        // this.sendBillRow.row.providerId = providerId;
      } else {
        this.onBatchSendEmail();
      }
    },

    // 批量发送邮件
    onBatchSendEmail() {
      const { selectData } = this;

      if (!Array.isArray(selectData) || selectData.length === 0) {
        return;
      }

      // 初始化变量
      let maintained = 0;
      let unMaintained = 0;
      const numberList = [];
      const unList = [];
      let principleCode = ''; // 未存在邮箱供应商

      selectData.forEach(item => {
        if (!item.providerCompanyEmail) {
          unList.push(item);
        }
        numberList.push(item.payableNumber);
      });

      unMaintained = unList.length;
      maintained = selectData.length;
      principleCode = unList.map(item => this.extractContent(item.providerName)).join('，');

      console.log('maintained', maintained, unMaintained, unList, principleCode);

      // 配置化 callBackUrl
      const RES_OBJ = {
        callBackUrl: `${document.location.origin}/finance/payableManagement/UploadContas`, // 外链地址
        payableNumberList: [] // 批次号
      };

      // 动态生成提示信息
      const tips = unMaintained > 0
        ? this.$t('collectionCenter.tips')
        : this.$t('receivablePayable.batchSendEmail');

      const h = this.$createElement;
      const msg = unMaintained > 0
        ? h('p', null, [
          h('span', null, this.$t('receivablePayable.existenceDeclaration')),
          h('i', { style: 'color: red; fontWeight: bold;' }, unMaintained),
          h('span', null, this.$t('receivablePayable.unitIndicator')),
          h('span', null, this.$t('receivablePayable.unmaintainedReconciliationEmailProvider')),
          h('span', null, ','),
          h('span', null, this.$t('receivablePayable.maintenancePrompt')),
          h('p', { style: 'color: #000; fontWeight: bold; word-wrap: break-word;' }, principleCode)
        ])
        : h('p', null, [
          h('span', null, this.$t('receivablePayable.batchSupplierConfirmationHeader')),
          h('i', { style: 'color: red; fontWeight: bold;' }, maintained),
          h('span', null, this.$t('receivablePayable.unitIndicator')),
          h('span', null, ','),
          h('span', null, this.$t('receivablePayable.confirmationPrompt'))
        ]);

      console.log(tips, msg);

      // 弹窗确认
      this.$msgbox({
        title: tips,
        message: msg,
        showConfirmButton: unMaintained === 0,
        showCancelButton: true,
        confirmButtonText: this.$t('collectionCenter.confirm'), // 确认
        cancelButtonText: this.$t('collectionCenter.cancel'), // 取消
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            RES_OBJ.payableNumberList = numberList;
            apiSitePayableSendMail(RES_OBJ, false)
              .then(res => {
                if (res.code === 200) {
                  done();
                }
              })
              .catch(err => {
                console.log('API 调用失败:', err);
              })
              .finally(() => {
                setTimeout(() => {
                  instance.confirmButtonLoading = false;
                }, 300);
              });
          } else {
            done();
          }
        }
      }).then(res => {
        this.$message.success(this.$t('basicData.TheOperationSucceeded'));
      }).catch(() => {
        console.log('取消操作');
      });
    },

    // 关闭发送邮件弹窗
    onEnvUmEmailClose(isBool) {
      this.sendBillRow.isShow = false;
      isBool && this.searchResources();
    },

    // 导出账单文件
    onExportBillFile() {
      const { selectData, tableData } = this;
      try {
        // 指定导出
        if (selectData.length > 0) {
          // 撤回中不支持导出
          const arrData = selectData.filter(item => item.payableStatus !== 5);
          console.log(arrData);
          if (arrData.length === 0) {
            this.$message.warning(this.$t('collectionCenter.CannotExportDataWithPaymentStatusAsRevoked'));
            return;
          }
          // 没有上传文件不支持导出(获取账单的文件)
          const arr = getFileUrl(arrData);
          if (arr.length > 0) {
            exportFile(arr);
          } else {
            this.$message.warning(this.$t('collectionCenter.nullMsg'));
          }
          return;
        }

        // 未勾选默认导出当前页数据
        const arrData = tableData.filter(item => item.payableStatus !== 5);
        const arr = getFileUrl(arrData);
        if (arr.length > 0) {
          exportFile(arr);
        } else {
          this.$message.warning(this.$t('collectionCenter.nullMsg'));
        }
      } catch (error) {
        console.info(error);
      }
    },

    // 导出
    onExport() {
      const { selectData } = this;
      const { params } = this.getQueryData();

      // 指定导出
      if (selectData.length > 0) {
        params.ids = [];
        selectData.map(item => {
          if (item.payableStatus !== 5) {
            params.ids.push(item.id);
          }
        });
      }

      apiSitePayableExport(params).then(() => {
        goFinanceExportPage();
      });
    },

    // 编辑文件
    openUpdateFile() {
      const row = this.selectData[0];
      console.log('row', row);
      const { id, emailSenderFileUrlArr, requestPaymentStatus } = row;
      if (requestPaymentStatus) {
        return;
      }
      this.$refs.updateFileRef.open(id, emailSenderFileUrlArr, 2);
    },

    // 字符处理
    extractContent(str) {
      const regex = /\((.*?)\)/;
      const match = str.match(regex);
      return match ? match[1] : null;
    }
  }
};
</script>

<style scoped lang="scss">
.batchNumber {
  color: #007efd;
  cursor: pointer;
}

.remarkStyle p {
  padding: 0!important;
  margin: 0!important;
}
</style>
